module.exports = __webpack_public_path__ + "img/40_01_009_577.0960d76f.jpg";